<template lang="">
  <div>
    <i class="el-icon-info useTips" style="color: gray">
      该网页搭配微信小程序使用<br />&nbsp;&nbsp;&nbsp;&nbsp;微信搜索“shishi鉴定”</i
    >
    <!-- <el-calendar v-model="value"> </el-calendar> -->
    <el-calendar>
      <template slot="dateCell" slot-scope="{ date, data }">
        <div class="ActivityContent">
          <p style="margin: 0; font-weight: bold">
            {{ data.day.split("-").slice(2).join("-") }} 
          </p> 
        </div>
      </template></el-calendar
    >  
  </div>
</template>
<script> 
export default {
  name: "Overview",
  data() {
    return { 
      IsMobile: false, 
    };
  }, 
  mounted() {
    if (window.screen.width < 768) {
      this.IsMobile = true;
    } 
  },
};
</script>
<style>
.useTips {
  display: none;
  margin-bottom: 3px;
  font-size: smaller;
} 
@media screen and (max-width: 768px) {
  .el-calendar__header {
    padding: 0;
  }
  .el-calendar__body {
    padding: 0;
  }
  .el-calendar__header .el-button-group .el-button {
    padding: 7px 7px;
  }
  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: 270px;
  }
  .useTips {
    display: block;
  }
}
</style>
